import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=386be32e&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('386be32e')) {
      api.createRecord('386be32e', component.options)
    } else {
      api.reload('386be32e', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=386be32e&", function () {
      api.rerender('386be32e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-45L4qOw433b4x/JS/comp/IncreaseNumber.vue"
export default component.exports